import script from "./ReviewRequirements.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewRequirements.vue?vue&type=script&setup=true&lang=js"

import "./ReviewRequirements.vue?vue&type=style&index=0&id=0f942cb0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f942cb0"]])

export default __exports__